import { render } from "./CardResumenServiciosBuscador.vue?vue&type=template&id=cfe8813e"
import script from "./CardResumenServiciosBuscador.vue?vue&type=script&lang=js"
export * from "./CardResumenServiciosBuscador.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__